// extracted by mini-css-extract-plugin
module.exports = {"suggestion-item":"suggestion-item--2zv0BOCAXL","suggestionItem":"suggestion-item--2zv0BOCAXL","suggestion":"suggestion--27b2p-cWpI","icon":"icon--1jKbkXmbQ9"};